import {Bounce, toast, ToastContainer} from "react-toastify";
import {Button, Col, Row} from "react-bootstrap";
import PropTypes from "prop-types";

export function ConfirmToast(props) {

    const {executeFunction, message, title, className} = props;
    const notify = (e) => {
        e.preventDefault();
        toast(<div>
            <Row className={"g-0"}>
                <Col xs={12} className={"mb-3"}>
                    {message}
                </Col>
                <Col className={'text-end me-2'}>
                    <Button onClick={() => executeFunction()}>Ja</Button>
                </Col>
                <Col className={"ms-2"}>
                    <Button>Nee</Button>
                </Col>
            </Row>
        </div>, {
            position: "top-right",
            autoClose: 5000,
            type: "warning",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
        });
    }

    return (
        <div>
            <Button className={className} onClick={(e) => notify(e)}>{title ? title : "Enter title!!"}</Button>
            <ToastContainer/>
        </div>
    );
}

ConfirmToast.propTypes = {
    message: PropTypes.string.isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
    executeFunction: PropTypes.func
};